import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@app/app.module';
import { environment } from '@env/environment';
import mainExtended from 'main-extended';
import { enableAkitaProdMode, akitaDevtools, __stores__, Query, QueryEntity } from '@datorama/akita';
import { Logger } from 'timeghost-api';
import * as Sentry from '@sentry/angular';
import { Integrations } from '@sentry/tracing';
import { AkitaPersistState } from 'main.store';
if (environment.enableSentry) {
  Sentry.init({
    dsn: 'https://02a07543cb1847469eb7fc2c0a0187a5@o448905.ingest.sentry.io/5431009',
    debug: !environment.production,
    ignoreErrors: [
      'ExpressionChangedAfterItHasBeenCheckedError',
      'InteractionRequiredAuthError',
      `NetworkError: Failed to execute 'send' on 'XMLHttpRequest'`,
      `BrowserAuthError: user_cancelled: User cancelled the flow.`,
      /Non-Error exception captured with keys/,
      /(\w+)-extension[://]/,
      /(.*)graph.microsoft.com\/v1.0\/users\/(.*)\/photos\//,
      /\.(jp(e)?g|png|gif)$/,
      /fwcrm is not defined/,
      /Cannot start a HubConnection/,
      /executing a cancelled action/,
      /^macroTask/,
    ],
    release: environment.version,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: environment.production
          ? [environment.clientUrl]
          : ['localhost', 'localhost:4200', environment.clientUrl],
        routingInstrumentation: Sentry.routingInstrumentation,
      }),
    ],
    tracesSampleRate: environment.production ? 1 : 0,
  });
  Sentry.setTags({
    environment: environment.production ? 'production' : 'dev',
    release: environment.releaseName || 'dev',
    'git-version': environment.version,
  });
}
if (environment.production) {
  enableProdMode();
  enableAkitaProdMode();
  Logger.enableProductionMode();
} else {
  akitaDevtools();
}
(function () {
  mainExtended();
  platformBrowserDynamic([AkitaPersistState]) // required to inject persistState into child classes, sets before app module init
    .bootstrapModule(AppModule)
    .then(() => {
      if (!environment.production)
        window.$$akita = {
          stores: __stores__,
          queries: Object.entries(__stores__).reduce((acc, [name, store]) => {
            if (!acc[name]) acc[name] = 'entityActions' in store ? new QueryEntity(store as any) : new Query(store);
            return acc;
          }, {}),
        };
    })
    .catch((err) => console.log(err));
})();
